import { Card, FormGroup, Select } from '@ksyos/design-system';
import { capitalize } from 'lodash';
import { useEffect, useState } from 'react';
import type { ManagerRoleName } from '@common/enums';
import { getLanguage } from '@common/translate/translate';
import { useAbortableFetch } from '@frontend/utils';

interface IRolesProps {
    onUpdateManagerRoleId: (id?: string) => void;
}

interface IManagerRole {
    label: ManagerRoleName;
    value: string;
}

export function Roles(props: IRolesProps) {
    const abortableFetch = useAbortableFetch();
    const translate = getLanguage();
    const [allManagerRoles, setAllManagerRoles] = useState<IManagerRole[]>([]);
    const [managerRoleId, setManagerRoleId] = useState<string>();

    useEffect(() => {
        loadAllManagerRoles();
    }, []);

    useEffect(() => {
        props.onUpdateManagerRoleId(managerRoleId);
    }, [managerRoleId]);

    return (
        <>
            <Card>
                <Card.Header title={capitalize(translate.common.role)} />

                <Card.Body>
                    <FormGroup label={capitalize(translate.common.role)}>
                        <Select
                            className="automation-choose-authorization"
                            isClearable={true}
                            menuPlacement="top"
                            onChange={(item) => setManagerRoleId(item?.value)}
                            options={allManagerRoles}
                            placeholder={translate.practitioner.chooseRole}
                            value={allManagerRoles.find((managerRole) => managerRole.value === managerRoleId)}
                        />
                    </FormGroup>
                </Card.Body>
            </Card>
        </>
    );

    async function loadAllManagerRoles() {
        const url = `/api/ksyos/managerRoles`;
        const results: IManagerRole[] = (await abortableFetch.fetchJson(url, 'GET')).json?.items.map(
            (result: { id: string; name: ManagerRoleName }) => ({
                value: result.id,
                label: result.name,
            })
        );
        setAllManagerRoles(results);
    }
}
